var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "mobile-navigation",
      class: { open: _vm.isMobileNavigationOpen },
    },
    [
      [
        _c(
          "ul",
          {
            directives: [{ name: "menu", rawName: "v-menu" }],
            staticClass: "mainmenu w-100 p-0 m-0 menu-active",
            attrs: { id: "menu-1" },
          },
          [
            _vm.dataContainer1.parent
              ? _c(
                  "li",
                  {
                    staticClass: "ddown",
                    on: {
                      click: function ($event) {
                        return _vm.slideTo(
                          (_vm.dataContainer1.parent &&
                            _vm.dataContainer1.parent.parent) ||
                            null,
                          true
                        )
                      },
                    },
                  },
                  [
                    _c(
                      "span",
                      {
                        staticClass:
                          "nav-direction d-flex align-items-center mHeader",
                      },
                      [
                        _vm.selectedCat
                          ? [
                              _c("i", {
                                staticClass: "fa fa-long-arrow-left",
                                attrs: { "aria-hidden": "true" },
                              }),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "flex-fill text-center" },
                                [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(_vm.selectedCat.details[0].name) +
                                      "\n                        "
                                  ),
                                ]
                              ),
                            ]
                          : _vm._e(),
                      ],
                      2
                    ),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm._l(_vm.dataContainer1.categories, function (category) {
              return _c("li", { staticClass: "ddown" }, [
                _c("a", { attrs: { href: _vm.getCategoryUrl(category.url) } }, [
                  _vm._v(_vm._s(category.details[0].name)),
                ]),
                _vm._v(" "),
                category.childCount
                  ? _c(
                      "span",
                      {
                        staticClass: "nav-direction",
                        on: {
                          click: function ($event) {
                            return _vm.slideTo(category)
                          },
                        },
                      },
                      [
                        _c("i", {
                          staticClass: "fa fa-angle-right",
                          attrs: { "aria-hidden": "true" },
                        }),
                      ]
                    )
                  : _vm._e(),
              ])
            }),
            _vm._v(" "),
            _vm.dataContainer1.categories[0]
              ? _vm._l(
                  _vm.dataContainer1.categories[0].siblingCount -
                    _vm.dataContainer1.categories.length,
                  function (number) {
                    return _c("li", { staticClass: "ddown" }, [
                      _c("span", {
                        staticClass: "nav-placeholder m-3",
                        style: { width: Math.random() * 20 + 60 + "%" },
                      }),
                    ])
                  }
                )
              : _vm.dataContainer1.parent
              ? _vm._l(_vm.dataContainer1.parent.childCount, function (number) {
                  return _c("li", { staticClass: "ddown" }, [
                    _c("span", {
                      staticClass: "nav-placeholder m-3",
                      style: { width: Math.random() * 20 + 60 + "%" },
                    }),
                  ])
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.breadcrumbs.length == 0 && _vm.langs.length > 1
              ? [
                  _c("li", [
                    _c(
                      "span",
                      {
                        staticClass:
                          "nav-direction d-flex align-items-center mHeader",
                      },
                      [
                        _c("div", { staticClass: "flex-fill text-center" }, [
                          _vm._v(
                            "\n                            " +
                              _vm._s(
                                _vm.$translate(
                                  "Klettershop5::Template.headerLangs"
                                )
                              ) +
                              "\n                        "
                          ),
                        ]),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _vm.langs.length > 1
                    ? _c("li", { staticClass: "ddown" }, [
                        _c("a", { attrs: { href: _vm.urlDE } }, [
                          _c("img", {
                            attrs: {
                              src: "https://cdn02.plentymarkets.com/5rubvkuloybx/frontend/Template/Images/Global/flags/mini/de.png",
                            },
                          }),
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$translate("Klettershop5::Template.german")
                              ) +
                              "\n                    "
                          ),
                        ]),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.langs.indexOf("en") > -1
                    ? _c("li", { staticClass: "ddown" }, [
                        _c("a", { attrs: { href: _vm.urlEN } }, [
                          _c("img", {
                            attrs: {
                              src: "https://cdn02.plentymarkets.com/5rubvkuloybx/frontend/Template/Images/Global/flags/mini/gb.png",
                            },
                          }),
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$translate(
                                  "Klettershop5::Template.englisch"
                                )
                              ) +
                              "\n                    "
                          ),
                        ]),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.langs.indexOf("it") > -1
                    ? _c("li", { staticClass: "ddown" }, [
                        _c("a", { attrs: { href: _vm.urlIT } }, [
                          _c("img", {
                            attrs: {
                              src: "https://cdn02.plentymarkets.com/5rubvkuloybx/frontend/Template/Images/Global/flags/mini/it.png",
                            },
                          }),
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$translate("Klettershop5::Template.italian")
                              ) +
                              "\n                    "
                          ),
                        ]),
                      ])
                    : _vm._e(),
                ]
              : _vm._e(),
            _vm._v(" "),
            _vm.breadcrumbs.length == 0
              ? [
                  _vm._m(0),
                  _vm._v(" "),
                  _c("li", { staticClass: "ddown" }, [
                    _c("div", [
                      _c(
                        "svg",
                        {
                          staticStyle: {
                            "max-width": "25px",
                            "max-height": "25px",
                          },
                          attrs: {
                            xmlns: "http://www.w3.org/2000/svg",
                            viewBox: "0 0 24 24",
                          },
                        },
                        [
                          _c("title", [_vm._v("invoice-text-check-outline")]),
                          _vm._v(" "),
                          _c("path", {
                            attrs: {
                              d: "M12 20L13.3 20.86C13.1 20.28 13 19.65 13 19C13 18.76 13 18.5 13.04 18.29L12 17.6L9 19.6L6 17.6L5 18.26V5H19V13C19.7 13 20.37 13.12 21 13.34V3H3V22L6 20L9 22L12 20M17 9V7H7V9H17M15 13V11H7V13H15M15.5 19L18.25 22L23 17.23L21.84 15.82L18.25 19.41L16.66 17.82L15.5 19Z",
                            },
                          }),
                        ]
                      ),
                      _vm._v(
                        "\n                  Für Behörden: Kauf auf Rechnung\n                "
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("li", { staticClass: "ddown" }, [
                    _c("div", [
                      _c(
                        "svg",
                        {
                          staticStyle: {
                            "max-width": "25px",
                            "max-height": "25px",
                          },
                          attrs: {
                            xmlns: "http://www.w3.org/2000/svg",
                            viewBox: "0 0 24 24",
                          },
                        },
                        [
                          _c("title", [_vm._v("cash")]),
                          _vm._v(" "),
                          _c("path", {
                            attrs: {
                              d: "M3,6H21V18H3V6M12,9A3,3 0 0,1 15,12A3,3 0 0,1 12,15A3,3 0 0,1 9,12A3,3 0 0,1 12,9M7,8A2,2 0 0,1 5,10V14A2,2 0 0,1 7,16H17A2,2 0 0,1 19,14V10A2,2 0 0,1 17,8H7Z",
                            },
                          }),
                        ]
                      ),
                      _vm._v(
                        "\n                  Bestpreis-Garantie\n                "
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("li", { staticClass: "ddown" }, [
                    _c("div", [
                      _c(
                        "svg",
                        {
                          staticStyle: {
                            "max-width": "25px",
                            "max-height": "25px",
                          },
                          attrs: {
                            xmlns: "http://www.w3.org/2000/svg",
                            viewBox: "0 0 24 24",
                          },
                        },
                        [
                          _c("title", [_vm._v("floor-plan")]),
                          _vm._v(" "),
                          _c("path", {
                            attrs: {
                              d: "M10,5V10H9V5H5V13H9V12H10V17H9V14H5V19H12V17H13V19H19V17H21V21H3V3H21V15H19V10H13V15H12V9H19V5H10Z",
                            },
                          }),
                        ]
                      ),
                      _vm._v(
                        "\n                  Kostenloser Belegungsplan\n                "
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("li", { staticClass: "ddown" }, [
                    _c("div", [
                      _c(
                        "svg",
                        {
                          staticStyle: {
                            "max-width": "25px",
                            "max-height": "25px",
                          },
                          attrs: {
                            xmlns: "http://www.w3.org/2000/svg",
                            viewBox: "0 0 24 24",
                          },
                        },
                        [
                          _c("title", [_vm._v("room-service-outline")]),
                          _vm._v(" "),
                          _c("path", {
                            attrs: {
                              d: "M12,5A2,2 0 0,1 14,7C14,7.24 13.96,7.47 13.88,7.69C17.95,8.5 21,11.91 21,16H3C3,11.91 6.05,8.5 10.12,7.69C10.04,7.47 10,7.24 10,7A2,2 0 0,1 12,5M22,19H2V17H22V19M12,9.5C8.89,9.5 6.25,11.39 5.34,14H18.66C17.75,11.39 15.11,9.5 12,9.5Z",
                            },
                          }),
                        ]
                      ),
                      _vm._v(
                        "\n                  Full-Service-Anbieter\n                "
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("li", { staticClass: "ddown" }, [
                    _c(
                      "a",
                      {
                        staticClass: "btn btn-primary",
                        attrs: { href: _vm.benefitLink },
                      },
                      [
                        _c("i", {
                          staticClass: "fa fa-angle-right",
                          attrs: { "aria-hidden": "true" },
                        }),
                        _vm._v(
                          "\n                  Zu den Vorteilen\n                "
                        ),
                      ]
                    ),
                  ]),
                ]
              : _vm._e(),
          ],
          2
        ),
        _vm._v(" "),
        _c(
          "ul",
          {
            directives: [{ name: "menu", rawName: "v-menu" }],
            staticClass: "mainmenu w-100 p-0 m-0",
            attrs: { id: "menu-2" },
          },
          [
            _vm.dataContainer2.parent
              ? _c(
                  "li",
                  {
                    on: {
                      click: function ($event) {
                        return _vm.slideTo(
                          (_vm.dataContainer2.parent &&
                            _vm.dataContainer2.parent.parent) ||
                            null,
                          true
                        )
                      },
                    },
                  },
                  [
                    _c(
                      "span",
                      {
                        staticClass:
                          "nav-direction d-flex align-items-center mHeader",
                      },
                      [
                        _vm.selectedCat
                          ? [
                              _c("i", {
                                staticClass: "fa fa-long-arrow-left",
                                attrs: { "aria-hidden": "true" },
                              }),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "flex-fill text-center" },
                                [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(_vm.selectedCat.details[0].name) +
                                      "\n                        "
                                  ),
                                ]
                              ),
                            ]
                          : _vm._e(),
                      ],
                      2
                    ),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm._l(_vm.dataContainer2.categories, function (category) {
              return _c("li", { staticClass: "ddown" }, [
                _c("a", { attrs: { href: _vm.getCategoryUrl(category.url) } }, [
                  _vm._v(_vm._s(category.details[0].name)),
                ]),
                _vm._v(" "),
                category.childCount
                  ? _c(
                      "span",
                      {
                        staticClass: "nav-direction",
                        on: {
                          click: function ($event) {
                            return _vm.slideTo(category)
                          },
                        },
                      },
                      [
                        _c("i", {
                          staticClass: "fa fa-lg fa-angle-right",
                          attrs: { "aria-hidden": "true" },
                        }),
                      ]
                    )
                  : _vm._e(),
              ])
            }),
            _vm._v(" "),
            _vm.dataContainer2.categories[0]
              ? _vm._l(
                  _vm.dataContainer2.categories[0].siblingCount -
                    _vm.dataContainer2.categories.length,
                  function (number) {
                    return _c("li", { staticClass: "ddown" }, [
                      _c("span", {
                        staticClass: "nav-placeholder m-3",
                        style: { width: Math.random() * 20 + 60 + "%" },
                      }),
                    ])
                  }
                )
              : _vm.dataContainer2.parent
              ? _vm._l(_vm.dataContainer2.parent.childCount, function (number) {
                  return _c("li", { staticClass: "ddown" }, [
                    _c("span", {
                      staticClass: "nav-placeholder m-3",
                      style: { width: Math.random() * 20 + 60 + "%" },
                    }),
                  ])
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.breadcrumbs.length == 0 && _vm.langs.length > 1
              ? [
                  _c("li", [
                    _c(
                      "span",
                      {
                        staticClass:
                          "nav-direction d-flex align-items-center mHeader",
                      },
                      [
                        _c("div", { staticClass: "flex-fill text-center" }, [
                          _vm._v(
                            "\n                            " +
                              _vm._s(
                                _vm.$translate(
                                  "Klettershop5::Template.headerLangs"
                                )
                              ) +
                              "\n                        "
                          ),
                        ]),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _vm.langs.length > 1
                    ? _c("li", { staticClass: "ddown" }, [
                        _c("a", { attrs: { href: _vm.urlDE } }, [
                          _c("img", {
                            attrs: {
                              src: "https://cdn02.plentymarkets.com/5rubvkuloybx/frontend/Template/Images/Global/flags/DE.png",
                            },
                          }),
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$translate("Klettershop5::Template.german")
                              ) +
                              "\n                    "
                          ),
                        ]),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.langs.indexOf("en") > -1
                    ? _c("li", { staticClass: "ddown" }, [
                        _c("a", { attrs: { href: _vm.urlEN } }, [
                          _c("img", {
                            attrs: {
                              src: "https://cdn02.plentymarkets.com/5rubvkuloybx/frontend/Template/Images/Global/flags/GB.png",
                            },
                          }),
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$translate(
                                  "Klettershop5::Template.englisch"
                                )
                              ) +
                              "\n                    "
                          ),
                        ]),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.langs.indexOf("it") > -1
                    ? _c("li", { staticClass: "ddown" }, [
                        _c("a", { attrs: { href: _vm.urlIT } }, [
                          _c("img", {
                            attrs: {
                              src: "https://cdn02.plentymarkets.com/5rubvkuloybx/frontend/Template/Images/Global/flags/mini/it.png",
                            },
                          }),
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$translate("Klettershop5::Template.italian")
                              ) +
                              "\n                    "
                          ),
                        ]),
                      ])
                    : _vm._e(),
                ]
              : _vm._e(),
            _vm._v(" "),
            _vm.breadcrumbs.length == 0
              ? [
                  _vm._m(1),
                  _vm._v(" "),
                  _c("li", { staticClass: "ddown" }, [
                    _c("div", [
                      _c(
                        "svg",
                        {
                          staticStyle: {
                            "max-width": "25px",
                            "max-height": "25px",
                          },
                          attrs: {
                            xmlns: "http://www.w3.org/2000/svg",
                            viewBox: "0 0 24 24",
                          },
                        },
                        [
                          _c("title", [_vm._v("invoice-text-check-outline")]),
                          _vm._v(" "),
                          _c("path", {
                            attrs: {
                              d: "M12 20L13.3 20.86C13.1 20.28 13 19.65 13 19C13 18.76 13 18.5 13.04 18.29L12 17.6L9 19.6L6 17.6L5 18.26V5H19V13C19.7 13 20.37 13.12 21 13.34V3H3V22L6 20L9 22L12 20M17 9V7H7V9H17M15 13V11H7V13H15M15.5 19L18.25 22L23 17.23L21.84 15.82L18.25 19.41L16.66 17.82L15.5 19Z",
                            },
                          }),
                        ]
                      ),
                      _vm._v(
                        "\n                Für Behörden: Kauf auf Rechnung\n              "
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("li", { staticClass: "ddown" }, [
                    _c("div", [
                      _c(
                        "svg",
                        {
                          staticStyle: {
                            "max-width": "25px",
                            "max-height": "25px",
                          },
                          attrs: {
                            xmlns: "http://www.w3.org/2000/svg",
                            viewBox: "0 0 24 24",
                          },
                        },
                        [
                          _c("title", [_vm._v("cash")]),
                          _vm._v(" "),
                          _c("path", {
                            attrs: {
                              d: "M3,6H21V18H3V6M12,9A3,3 0 0,1 15,12A3,3 0 0,1 12,15A3,3 0 0,1 9,12A3,3 0 0,1 12,9M7,8A2,2 0 0,1 5,10V14A2,2 0 0,1 7,16H17A2,2 0 0,1 19,14V10A2,2 0 0,1 17,8H7Z",
                            },
                          }),
                        ]
                      ),
                      _vm._v(
                        "\n                Bestpreis-Garantie\n              "
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("li", { staticClass: "ddown" }, [
                    _c("div", [
                      _c(
                        "svg",
                        {
                          staticStyle: {
                            "max-width": "25px",
                            "max-height": "25px",
                          },
                          attrs: {
                            xmlns: "http://www.w3.org/2000/svg",
                            viewBox: "0 0 24 24",
                          },
                        },
                        [
                          _c("title", [_vm._v("floor-plan")]),
                          _vm._v(" "),
                          _c("path", {
                            attrs: {
                              d: "M10,5V10H9V5H5V13H9V12H10V17H9V14H5V19H12V17H13V19H19V17H21V21H3V3H21V15H19V10H13V15H12V9H19V5H10Z",
                            },
                          }),
                        ]
                      ),
                      _vm._v(
                        "\n                Kostenloser Belegungsplan\n              "
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("li", { staticClass: "ddown" }, [
                    _c("div", [
                      _c(
                        "svg",
                        {
                          staticStyle: {
                            "max-width": "25px",
                            "max-height": "25px",
                          },
                          attrs: {
                            xmlns: "http://www.w3.org/2000/svg",
                            viewBox: "0 0 24 24",
                          },
                        },
                        [
                          _c("title", [_vm._v("room-service-outline")]),
                          _vm._v(" "),
                          _c("path", {
                            attrs: {
                              d: "M12,5A2,2 0 0,1 14,7C14,7.24 13.96,7.47 13.88,7.69C17.95,8.5 21,11.91 21,16H3C3,11.91 6.05,8.5 10.12,7.69C10.04,7.47 10,7.24 10,7A2,2 0 0,1 12,5M22,19H2V17H22V19M12,9.5C8.89,9.5 6.25,11.39 5.34,14H18.66C17.75,11.39 15.11,9.5 12,9.5Z",
                            },
                          }),
                        ]
                      ),
                      _vm._v(
                        "\n                Full-Service-Anbieter\n              "
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("li", { staticClass: "ddown" }, [
                    _c(
                      "a",
                      {
                        staticClass: "btn btn-primary",
                        attrs: { href: _vm.benefitLink },
                      },
                      [
                        _c("i", {
                          staticClass: "fa fa-angle-right",
                          attrs: { "aria-hidden": "true" },
                        }),
                        _vm._v(
                          "\n                Zu den Vorteilen\n              "
                        ),
                      ]
                    ),
                  ]),
                ]
              : _vm._e(),
          ],
          2
        ),
      ],
      _vm._v(" "),
      !_vm.isNavigationInitialized ? [_c("loading-animation")] : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("li", [
      _c(
        "span",
        { staticClass: "nav-direction d-flex align-items-center mHeader" },
        [
          _c("div", { staticClass: "flex-fill text-center" }, [
            _vm._v(
              "\n                        Unsere Vorteile\n                    "
            ),
          ]),
        ]
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("li", [
      _c(
        "span",
        { staticClass: "nav-direction d-flex align-items-center mHeader" },
        [
          _c("div", { staticClass: "flex-fill text-center" }, [
            _vm._v(
              "\n                        Unsere Vorteile\n                    "
            ),
          ]),
        ]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }